<script>
  import { onMount } from "svelte";

  import { isObject, traverse } from "./utils.js";

  export let schema;
  export let id;
  export let value;

  let loading = true;

  const execCommand = code => new Function(`return ${ code }`)();

  const process_choices_list = choices_list => {
    const choices = [];
    for (const choice of choices_list) {
      const val = traverse(choice, schema.choice);

      if (schema.choice_label) {
        const label = traverse(choice, schema.choice_label);
        choices.push({ label, value: val });
      } else {
        choices.push(val);
      }
    }
    return choices;
  }

  const init = async () => {
    if ("choices" in schema && typeof schema.choices === 'string') {
      let url = schema.choices;
      // this allows urls like "{window.location.pathname}/events/new"
      for (const m of (url.match(/\{[a-zA-Z]*.*[a-zA-Z]*\}/) || [])) {
        url = url.replace(m, execCommand(m.substring(1, m.length-1)));
      }
      const opts = { "headers": { "Accept": "application/json" } };
      const resp = await fetch(url, opts);
      if (resp.ok) {
        const choices_json = await resp.json();
        const choices_list = schema.context ? choices_json[schema.context] : choices_json;
        if (isObject(choices_list)) {
          var choices = {}
          for(const [context, list_of_choices] of Object.entries(choices_list)) {
            choices[context] = process_choices_list(list_of_choices);
          }
        } else choices = process_choices_list(choices_list);
        schema.choices = choices;
        schema = schema;
        loading = false;
      }
    } else loading = false;
  }

  onMount(init);
</script>

{#if !loading}
  {#if schema.type == "array"}
    <select id={ id } multiple bind:value={ value }>
      {#if isObject(schema.choices)}
        {#each Object.entries(schema.choices) as [group, choices]}
          <optgroup label={ group }>
            {#each choices as choice}
              {#if isObject(choice)}
                <option value={ choice.value }>{ choice.label }</option>
              {:else}
                <option>{ choice }</option>
              {/if}
            {/each}
          </optgroup>
        {/each}
      {:else}
        {#each schema.choices as choice}
          {#if isObject(choice)}
            <option value={ choice.value }>{ choice.label }</option>
          {:else}
            <option>{ choice }</option>
          {/if}
        {/each}
      {/if}
    </select>
  {:else}
    <select id={ id } bind:value={ value }>
      <option disabled selected>Select a cronology</option>
      {#if isObject(schema.choices)}
        {#each Object.entries(schema.choices) as [group, choices]}
          <optgroup label={ group }>
            {#each choices as choice}
              {#if isObject(choice)}
                <option value={ choice.value }>{ choice.label }</option>
              {:else}
                <option>{ choice }</option>
              {/if}
            {/each}
          </optgroup>
        {/each}
      {:else}
        {#each schema.choices as choice}
          {#if isObject(choice)}
            <option value={ choice.value }>{ choice.label }</option>
          {:else}
            <option>{ choice }</option>
          {/if}
        {/each}
      {/if}
    </select>
  {/if}
{/if}
